import type { CoordenadorAvisoResumo } from '@/interfaces/coordenador/avisos';
import coordenadorAvisosService from '@/services/coordenadorAvisosService';
import { useAuthStore } from '@/stores/AuthStore';
import { useCursoStore } from '@/stores/CursoStore';
import { computed, ref } from 'vue';

const resumo = ref<CoordenadorAvisoResumo | null>(null);

export function useCoordenadorAvisosBadge() {
  const authStore = useAuthStore();
  const cursoStore = useCursoStore();

  const totalAvisos = computed(() => resumo.value?.total_avisos ?? 0);

  async function carregarResumoAvisos(): Promise<void> {
    const perfilCoordenacao = authStore.isCoordenador || authStore.isSecretaria || authStore.isCoordenadorTcc;
    const cursoId = cursoStore.cursoAtual?.id;
    if (!perfilCoordenacao || !cursoId) {
      resumo.value = null;
      return;
    }

    try {
      const response = await coordenadorAvisosService.getResumo(cursoId);
      resumo.value = response?.data ?? null;
    } catch {
      resumo.value = null;
    }
  }

  return { resumo, totalAvisos, carregarResumoAvisos };
}
